/*
 * @Author: 'qhy' '272921690@qq.com'
 * @Date: 2022-10-28 14:12:58
 * @LastEditors: 'qhy' '272921690@qq.com'
 * @LastEditTime: 2023-03-20 16:18:21
 * @FilePath: \edu_ytsr_show_total_vue\src\utils\config.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'


if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseImgURL ='http://apis.tszyjyw.com:19100/api/biz/'
    //  axios.defaults.baseImgURL ='http://edures.yunruanxinxi.cn:19100/api/biz/'; 
    // axios.defaults.baseImgURL ='http://192.168.0.55:30006/api/biz/'
    
}else if (process.env.NODE_ENV == 'production') {
    //axios.defaults.baseImgURL ='http://edures.yunruanxinxi.cn:19100/api/biz/'; 
    axios.defaults.baseImgURL ='http://apis.tszyjyw.com:19100/api/biz/'
}
axios.defaults.baseURL =`${ axios.defaults.baseImgURL}PlatformInterfaces`
export default {
    baseImgURL:axios.defaults.baseImgURL,
    baseURL:`${ axios.defaults.baseImgURL}PlatformInterfaces`,
    organizeId:'centralPlatformId',
    backUrl:'http://zykpc.tszyjyw.com'
} 